
import React from 'react';

interface DownloadStatusProps {
  selected: string[];
  videoStats: {
    totalVideos: number;
    formattedTotalDuration: string;
  };
}

export const DownloadStatus: React.FC<DownloadStatusProps> = ({
  selected,
  videoStats
}) => {
  // The entire component is being removed as requested
  return null;
};
